import {Component, OnDestroy, OnInit, Inject, PLATFORM_ID} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PageService } from '../_services/page.service';
import {Router, ActivatedRoute, ParamMap} from '@angular/router';
import { Page } from '../_models/page';
import {Subscription} from 'rxjs';
import {AppConstants} from '../_constants/constants';

@Component({
    selector: 'app-page',
    templateUrl: './page.component.html',
    styleUrls: ['./page.component.css'],
    standalone: false
})
export class PageComponent implements OnInit, OnDestroy {

  slug: string;
  loading = true;
  page: Page;
  pageSubscription: Subscription;
  loadingSubscription: Subscription;
  currentLanguage: string | null = null;

  constructor(private pageService: PageService, private router: Router,
              private activatedRoute: ActivatedRoute,
              @Inject(PLATFORM_ID) private platformId: Object) {
    this.slug = this.activatedRoute.snapshot.paramMap.get('slug') ?? '';
    this.pageSubscription = this.pageService.pageSubject.subscribe(
        (page: Page) => {
          this.page = page;
        },
        () => this.router.navigateByUrl('/'),
        () => this.loading = false
    );

    this.loadingSubscription = this.pageService.loadingSubject.subscribe(
        (v: boolean) => {
          this.loading = v;
        }
    );

  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.currentLanguage = localStorage.getItem(AppConstants.CURRENT_LANG_STORE_KEY);
    }
    this.pageService.getPage(this.slug);
  }


  ngOnDestroy(): void {
    this.pageSubscription.unsubscribe();
    this.loadingSubscription.unsubscribe();
  }

}
